import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Loader2, LogIn } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Anmeldung fehlgeschlagen.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-8">
        <div className="text-center space-y-2">
          <div className="font-display font-black text-3xl tracking-tight text-foreground">
            Friedrich·Trade
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground font-display">
            Allocation Hub
          </div>
        </div>

        <div className="border border-border bg-card p-6 space-y-5">
          <div className="font-display font-bold text-sm uppercase tracking-wider text-foreground">
            Anmelden
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs text-muted-foreground uppercase tracking-wider">E-Mail</Label>
              <Input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="name@example.com"
                required
                autoFocus
                className="bg-background border-border text-foreground placeholder:text-muted-foreground"
              />
            </div>

            <div className="space-y-1.5">
              <Label className="text-xs text-muted-foreground uppercase tracking-wider">Passwort</Label>
              <Input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="bg-background border-border text-foreground placeholder:text-muted-foreground"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-foreground text-background hover:opacity-90 font-display font-bold uppercase tracking-wider text-xs h-10"
            >
              {loading ? <Loader2 size={14} className="animate-spin mr-2" /> : <LogIn size={14} className="mr-2" />}
              Anmelden
            </Button>
          </form>
        </div>

        <div className="text-center text-[10px] text-zinc-600 font-display uppercase tracking-widest">
          Friedrich·Trade · Allocation Hub v1.0
        </div>
      </div>
    </div>
  );
}
